import React, { useEffect, useState } from "react";
import "../Styles/Cart.css";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementQuantity,
  decrementQuantity,
  removeItem,
} from "../Redux/Cart_System";
import { FaAngleLeft } from "react-icons/fa6";
import { SlHome } from "react-icons/sl";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import Footer from "../Core/Footer";
import { Checkout, getCoupon } from "../Services/Operations/ProductAPI";
import { SlTag } from "react-icons/sl";

const Cart = () => {
  const location = useLocation();
  const token = useSelector((state) => state.user.token);
  const [couponError, setCouponError] = useState("");
  const [discount, setDiscount] = useState(0);
  const [correctCoupon, setCorrectCoupon] = useState("");
  const [customTip, setCustomTip] = useState("");
  const [showCustomTipInput, setShowCustomTipInput] = useState(false);
  const { longitude, latitude } = location.state || {};
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const BASE_URL = "https://zotpot.in";

  const [store, setStore] = useState(null);
  const [products, setProducts] = useState([]);
  const cartItems = useSelector((state) => state.cart.items);
  const totalAmount = useSelector((state) => state.cart.totalAmount);
  const [cartActive, setCartActive] = useState([]);
  const [tip, setTip] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [inactiveItems, setInactiveItems] = useState([]);

  useEffect(() => {
    if (cartItems.length > 0) {
      setStore(cartItems[0].store);
      const allProducts = cartItems.map((item) => item.product);
      setProducts(allProducts);
      console.log("Store:", cartItems[0].store);
      console.log("Products:", allProducts);
    }
  }, [cartItems]);

  const [orderSuggestion, setOrderSuggestion] = useState("");
  const handleInputChange = (e) => {
    setOrderSuggestion(e.target.value);
  };

  const handlePositiveChange = (productId) => {
    dispatch(incrementQuantity(productId));
  };

  const handleNegativeChange = (productId) => {
    dispatch(decrementQuantity(productId));
  };

  const handleTipSelect = (value) => {
    if (value === "other") {
      setShowCustomTipInput(true);
      setTip(null);
    } else {
      setTip(value);
      setShowCustomTipInput(false);
    }
  };

  const handleCustomTipChange = (e) => {
    setCustomTip(e.target.value);
  };

  const getTipAmount = () => {
    return showCustomTipInput ? parseFloat(customTip) || 0 : tip || 0;
  };

  const handleCheckout = async (product) => {
    if (!token) {
      navigation("/login");
    } else {
      const formData = new FormData();
      product.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
      });
      for (let pair of formData.entries()) {
        //console.log(`${pair[0]}: ${pair[1]}`);
      }

      try {
        const response = await Checkout(formData);
        //console.log("checkout details : ", response);
        setCartActive(response);

        const inactiveItems = response.filter((item) => item.is_active === 0);
        //console.log("inactiveItems : ",inactiveItems)
        if (inactiveItems.length > 0) {
          setInactiveItems(inactiveItems);
          setShowPopup(true);
        } else {
          const amount = getTotalToPay().toFixed(2);
          const tipAmount = getTipAmount();
          const discountAmount = getDiscountAmount();
          console.log("store in cart : ", store);
          navigation("/checkout", {
            state: {
              totalAmount: amount,
              store,
              products,
              tipAmount,
              discountAmount,
              coupon,
              orderSuggestion,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching checkout details:", error);
      }
    }
  };

  const handleCoupon = async () => {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("coupon", coupon);
    formData.append("restaurant_id", store.id);
    formData.append("subtotal", totalAmount);

    try {
      const response = await getCoupon(formData);
      console.log("coupon details : ", response);

      if (response.success === true) {
        setCouponError("");
        setCorrectCoupon(response.description);
        setDiscount(0.05);
      } else if (response.success === false) {
        setCorrectCoupon("");
        setCouponError("Invalid Coupon");
        setDiscount(0);
      }
    } catch (error) {
      console.error("Error fetching coupon:", error);
    }
  };

  const getDiscountAmount = () => {
    return totalAmount * discount;
  };

  const getTotalToPay = () => {
    return totalAmount + 23 + getTipAmount() - getDiscountAmount();
  };
  const handleRemoveTip = () => {
    setTip(null);
    setCustomTip("");
    setShowCustomTipInput(false);
  };

  const handlePopupOk = () => {
    inactiveItems.forEach((item) => {
      //console.log("id : ",item.id)
      dispatch(removeItem(item.id));
    });
    setShowPopup(false);
    const amount = getTotalToPay().toFixed(2);
    const tipAmount = getTipAmount();
    const discountAmount = getDiscountAmount();
    navigation("/checkout", {
      state: {
        totalAmount: amount,
        store,
        products,
        tipAmount,
        discountAmount,
        coupon,
        orderSuggestion,
      },
    });
  };

  const handlePopupCancel = () => {
    setShowPopup(false);
  };

  return (
    <div style={{ padding: "0px 20px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "770px",
          margin: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FaAngleLeft onClick={() => navigation(-1)} />
          <p style={{ marginLeft: "23px" }}>CART</p>
        </div>
        <div style={{ display: "flex", gap: "20px", marginRight: "13px" }}>
          <Link to="/">
            <SlHome />
          </Link>
        </div>
      </div>
      {cartItems.length > 0 ? (
        <div className="cart-container">
          {store ? (
            <div
              style={{ height: "109px" }}
              className="store-item"
              key={store.id}
            >
              <img
                style={{ width: "111px" }}
                src={`${BASE_URL}${store.image}`}
                alt={store.name}
              />
              <div
                style={{
                  marginLeft: "20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <h3 style={{ margin: "0px" }}>{store.name}</h3>
                <p style={{ margin: "0px" }}>{store.description}</p>
                <div className="store-details">
                  <span>{store.rating}</span>
                  <span>{store.delivery_time} min</span>
                  <span>{store.price_range}rs</span>
                </div>
              </div>
            </div>
          ) : (
            <p>No store information available</p>
          )}

          <div className="Cart-all-item">
            <h3
              style={{
                margin: "0px",
                padding: "10px 0px",
                borderBottom: "1px solid #dddada",
              }}
            >
              ITEMS IN CART
            </h3>
            {products.map((product, index) => (
              <div className="cart-item" key={product.id}>
                <div className="item-name">
                  <span>{product.name}</span>
                </div>
                <div className="quantity-control">
                  <button onClick={() => handleNegativeChange(product.id)}>
                    -
                  </button>
                  <span>{product.quantity}</span>
                  <button onClick={() => handlePositiveChange(product.id)}>
                    +
                  </button>
                </div>
                <div className="price">₹{product.price * product.quantity}</div>
              </div>
            ))}
            <div className="advanced-order">
              <input
                style={{
                  width: "92%",
                  border: "none",
                  padding: "10px 12px",
                  outline: "none",
                }}
                placeholder="ADVANCED ORDER (Delivery Time)/ suggestion for order"
                type="text"
                value={orderSuggestion}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {/* Advanced Order Section */}
          {/* <div className="advanced-order">
                <FaClock /> ADVANCED ORDER (Delivery Time) / suggestion for order
            </div> */}

          {/* Tip your delivery partner section */}
          <div className="tip-section">
            <h3>TIP YOUR DELIVERY PARTNER</h3>
            <p>
              Thank your delivery partner for helping you stay safe indoors.
              Support them through these tough times with a tip.
            </p>
            <div className="tip-options">
              {[5, 10, 20].map((value) => (
                <button
                  key={value}
                  onClick={() => handleTipSelect(value)}
                  className={tip === value ? "selected" : ""}
                >
                  ₹{value}
                </button>
              ))}
              <button
                onClick={() => handleTipSelect("other")}
                className={showCustomTipInput ? "selected" : ""}
              >
                Other
              </button>
            </div>
            {showCustomTipInput && (
              <input
                type="number"
                placeholder="Tip Amount"
                value={customTip}
                min={1}
                onChange={handleCustomTipChange}
                style={{
                  width: "93%",
                  marginTop: "10px",
                  padding: "10px 9px",
                  outline: "none",
                  borderRadius: "5px",
                  border: "1px solid black",
                }}
              />
            )}
          </div>

          {/* Coupon section */}
          <div className="coupon-section">
            <input
              type="text"
              placeholder="COUPON"
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
            />
            <SlTag className="apply-tag" />
            <button className="apply-btn" onClick={handleCoupon}>
              Apply
            </button>
          </div>
          {couponError && <p className="error-message">{couponError}</p>}
          {!couponError && correctCoupon && (
            <p className="error-message1">{correctCoupon}</p>
          )}

          <div className="bill-container">
            <div className="bill-details">
              <h3>BILL DETAILS</h3>
              <div className="bill-item">
                <span>Item Total</span>
                <span>₹{totalAmount}</span>
              </div>
              {discount > 0 && (
                <div className="bill-item">
                  <span>Coupon</span>
                  <span style={{ color: "green" }}>
                    -5%(₹{getDiscountAmount().toFixed(2)})
                  </span>
                </div>
              )}

              <div className="bill-item">
                <span>
                  Delivery Charges <span className="distance">(2.6km)</span>
                </span>
                <span>₹23.00</span>
              </div>
              {getTipAmount() > 0 && (
                <div className="bill-item">
                  <span>Delivery Tip</span>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <span>₹{getTipAmount()}</span>
                    <span
                      style={{ textDecoration: "underline" }}
                      onClick={handleRemoveTip}
                    >
                      Remove Tip
                    </span>
                  </div>
                </div>
              )}

              <div className="bill-item total">
                <span>To Pay</span>
                <span>₹{getTotalToPay().toFixed(2)}</span>
              </div>
            </div>
            <div className="zigzag"></div>
          </div>
          <button
            onClick={() => {
              handleCheckout(products);
            }}
            className="btn-proceed"
          >
            PROCEED TO CHECKOUT
          </button>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          {" "}
          Ypur Cart is Empty contact 9564779055
        </div>
      )}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>
              Some items in your cart are inactive. Would you like to remove
              them?
            </p>
            <div className="popup-buttons">
              <button onClick={handlePopupCancel}>Cancel</button>
              <button onClick={handlePopupOk}>OK</button>
            </div>
          </div>
        </div>
      )}
      <Footer longitude={longitude} latitude={latitude} />
    </div>
  );
};

export default Cart;
